module.exports = __webpack_public_path__ + "static/media/camera-polaroid.9d6ccb56.svg";